/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Pages_NavInputs */

const en_us2_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile pages`)
};

const pt_br2_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas do perfil`)
};

const es_419_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas del perfil`)
};

const pt_pt2_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Páginas do perfil`)
};

const fr_fr2_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages du profil`)
};

const de_de2_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profilseiten`)
};

const it_it2_profile_pages_nav = /** @type {(inputs: Profile_Pages_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagine del profilo`)
};

/**
* | output |
* | --- |
* | "Profile pages" |
*
* @param {Profile_Pages_NavInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_pages_nav = /** @type {((inputs?: Profile_Pages_NavInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Pages_NavInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_pages_nav(inputs)
	if (locale === "es-419") return es_419_profile_pages_nav(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_pages_nav(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_pages_nav(inputs)
	if (locale === "de-DE") return de_de2_profile_pages_nav(inputs)
	if (locale === "it-IT") return it_it2_profile_pages_nav(inputs)
	return en_us2_profile_pages_nav(inputs)
});
export { profile_pages_nav as "profile.pages_nav" }